import React from "react";

interface HotNewsBadgeProps {
    isHot?: boolean;
    className?: string;
    size?: "xs" | "sm" | "md" | "lg";
}

const HotNewsBadge: React.FC<HotNewsBadgeProps> = ({
    isHot = false,
    className = "",
    size = "md",
}) => {
    if (!isHot) {
        return null;
    }

    const sizeClasses = {
        xs: "text-[10px] px-1.5 py-0.5 -top-1 -left-2",
        sm: "text-[10px] px-1.5 py-0.5 top-1 right-1",
        md: "text-sm px-3 py-1 top-2 right-2",
        lg: "text-base px-4 py-2",
    };

    return (
        <div
            className={`
                absolute z-10
                bg-gradient-to-r from-red-500/80 to-orange-500/60
                text-white font-bold rounded-full
                shadow-lg backdrop-blur-sm
                animate-pulse
                border border-red-400/50
                ${sizeClasses[size]}
                ${className}
            `}
            style={{
                background: "linear-gradient(45deg, #ef4444, #f97316)",
                color: "white",
                fontWeight: "bold",
                textShadow: "0 1px 2px rgba(0,0,0,0.5)",
            }}
        >
            🔥HOT
        </div>
    );
};

export default React.memo(HotNewsBadge);
